import { render, staticRenderFns } from "./institute_admin_layout.vue?vue&type=template&id=5d95eb26&"
import script from "./institute_admin_layout.vue?vue&type=script&lang=js&"
export * from "./institute_admin_layout.vue?vue&type=script&lang=js&"
import style0 from "./institute_admin_layout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports